
import React from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'

interface ResourceFiltersProps {
  selectedDomain: string
  selectedModule: string
  selectedView: string
  onDomainChange: (value: string) => void
  onModuleChange: (value: string) => void
  onViewChange: (value: string) => void
  availableModules: Array<{ value: string; label: string }>
}

const domains = [
  { value: 'self', label: 'Self' },
  { value: 'wealth', label: 'Wealth' },
  { value: 'social', label: 'Social' }
]

const viewOptions = [
  { value: 'my-resources', label: 'My Resources' },
  { value: 'discover-resources', label: 'Discover Resources' }
]

const ResourceFilters = ({
  selectedDomain,
  selectedModule,
  selectedView,
  onDomainChange,
  onModuleChange,
  onViewChange,
  availableModules
}: ResourceFiltersProps) => {
  return (
    <div className="flex items-center gap-4">
      <span className="text-sm font-medium text-gray-700">Filter:</span>
      
      {/* Domain Filter */}
      <Select value={selectedDomain} onValueChange={onDomainChange}>
        <SelectTrigger className="w-40">
          <SelectValue placeholder="Select Domain" />
        </SelectTrigger>
        <SelectContent>
          {domains.map(domain => (
            <SelectItem key={domain.value} value={domain.value}>
              {domain.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Module Filter */}
      <Select value={selectedModule} onValueChange={onModuleChange}>
        <SelectTrigger className="w-48">
          <SelectValue placeholder="Select Module" />
        </SelectTrigger>
        <SelectContent>
          {availableModules.map(module => (
            <SelectItem key={module.value} value={module.value}>
              {module.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* View Filter */}
      <Select value={selectedView} onValueChange={onViewChange}>
        <SelectTrigger className="w-48">
          <SelectValue placeholder="Select Status" />
        </SelectTrigger>
        <SelectContent>
          {viewOptions.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export default ResourceFilters
